export default __webpack_public_path__ + "static/media/transaction-image.e174b38d.svg";